import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../components/Topbar/Topbar";
// import Topbar from "../../../components/Topbar/Topbar";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../assets/img";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { useAsyncDebounce } from "react-table";
import { Table } from "../../components/Table/Table";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { post, get, patch, put } from "../../Services/ApiHandler";
import { checkPermission } from "../redux/api/PermissionManager";

const SOSAlert = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("User");
  const [selectedFilter, setSelectedFilter] = useState({
    search: paginationData?.[path]?.search ?? "",
  });
  const [list, setList] = useState([]);
  const [addPopup, setAddPopup] = useState(false);
  const [tip, setTip] = useState("");
  const [names, setNames] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  console.log("tips ", tip);
  const handleChangeFilter = (name, val) => {
    setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [page, selectedFilter]);

  const getList = async (pageNumber = 1) => {
    let res = await get(
      `https://backend.newvow.vowstays.com/master/settings/list/`,
    );
    console.log("wishlist res", res);
    if (res?.status === "success") {
      const allowedTypes = [15, 16];

      const filteredData = (res?.data ?? []).filter((item) =>
        allowedTypes.includes(item.type),
      );

      setList(filteredData);
    }
  };

  const handleStatus = async ({ id, status }) => {
    const formdata = new FormData();
    formdata.append("status", !status);
    const res = await patch(
      `${URLS.VOW_VERSION_UPDATE}${id}/status/`,
      formdata,
    );
    if (res?.status === "success") {
      toast.success(res?.message || "Status updated");
      getList(page);
    }
  };

  const submit = async () => {
    // let edit = typeof addPopup === "object";

    console.log("====================================");
    console.log("SDSADKSKADKASKDSAKDKAKSD", addPopup, tip);
    console.log("====================================");
    const formdata = new FormData();
    formdata.append("type", addPopup?.type);
    formdata.append("setting_value", tip);
    formdata.append("skip_version_check", true);
    let url = URLS.VOW_VERSION_UPDATE + `${addPopup.id}` + "/update/";

    const res = await put(url, formdata);
    console.log("res edit room category", res);
    if (res?.status === "success") {
      toast.success("Edited successfully");
      getList();
      setNames([]);
      setTip("");
      setAddPopup(false);
    }
    // if (!tip && names.length == 0) {
    //   toast.error("Please Add Tip");
    //   return;
    // }

    // let url = edit
    //   ? `${URLS.MASTERURL}${addPopup?.id}/edit/`
    //   : `${URLS.MASTERURL}add/`;
  };
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "SOS Type",
        accessor: "type_label",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Retry  Timing",
        accessor: "setting_value",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex justify-content-left">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={value}
                  onChange={() => {
                    if (checkPermission("CAN-STATUS-CHECK_IN")) {
                      handleStatus(row.original);
                    }
                  }}
                />
                <span className="slider"></span>
              </label>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "id",
      Cell: ({ value, row }) => (
        <div className="d-flex ac-js">
          {checkPermission("CAN-EDIT-CHECK_IN") && (
            <button
              onClick={() => {
                setAddPopup(row.original);
                setTip(row.original.setting_value);
              }}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
        </div>
      ),
    };
    return checkPermission("CAN-EDIT-CHECK_IN") ||
      checkPermission("CAN-DELETE-CHECK_IN")
      ? [...d, action]
      : d;
  }, [page]);
  return (
    <div>
      <Topbar header={"SOS Alert"} />

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={false}
      />

      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {typeof addPopup === "object" ? "Edit" : "Add"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setTip("");
                  setNames([]);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                    {addPopup.type_label}
                  </p>
                </div>
                {/* {typeof addPopup !== "object" && (
                  <div>
                    <div>
                      <div className="d-flex ae-jb input-border p-1">
                        <textarea
                          style={{ maxHeight: "80px" }}
                          // maxLength={250}
                          value={tip}
                          onChange={(e) => {
                            setTip(e.target.value);
                          }}
                          placeholder="Write Here...."
                          className="border-0 mb-3 w-80"
                        />
                        <button
                          onClick={() => {
                            setNames((prev) => [
                              ...prev.filter((i) => i !== tip),
                              tip,
                            ]);
                            setTip("");
                          }}
                          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1"
                          style={{ minWidth: "100px" }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    <div>
                      {names.length > 0 ? (
                        <ul
                          className="input-border overflow-scroll mt-2"
                          style={{ minHeight: "50px", maxHeight: "200px" }}
                        >
                          {names?.map((name, index) => {
                            return (
                              <li
                                className="d-flex as-js gap-3 mt-2"
                                key={index}
                              >
                                <img
                                  src={arrow_icon}
                                  className="bullet-btn"
                                  alt=""
                                />
                                <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                                  {name}
                                </p>
                                <img
                                  src={delete_icon}
                                  className="delete-btn"
                                  onClick={() => {
                                    setNames((prev) =>
                                      prev.filter((i) => i !== name),
                                    );
                                  }}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )} */}
                {typeof addPopup === "object" && (
                  <input
                    type="text"
                    inputMode="numeric"
                    value={tip}
                    onChange={(e) => {
                      let val = e.target.value;

                      // allow only digits
                      val = val.replace(/[^0-9]/g, "");

                      // max 4 digits
                      if (val.length > 4) {
                        val = val.slice(0, 4);
                      }

                      // max value 1440
                      if (val !== "" && Number(val) > 1440) {
                        val = "1440";
                      }

                      setTip(val);
                    }}
                    placeholder="Enter value in minutes "
                    className="input-box"
                  />
                )}
              </div>
            </div>

            <div className="d-flex ac-je px-2 mt-4">
              <button
                onClick={() => {
                  submit();
                }}
                className="submit-btn f2 w-40 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
              >
                {" "}
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SOSAlert;
